/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_Requires_UpperInputs */

const nl_auth_password_errors_password_requires_upper = /** @type {(inputs: Auth_Password_Errors_Password_Requires_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wachtwoord moet minimaal één hoofdletter bevatten`)
};

/**

* @param {Auth_Password_Errors_Password_Requires_UpperInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_requires_upper = /** @type {((inputs?: Auth_Password_Errors_Password_Requires_UpperInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_Requires_UpperInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_requires_upper(inputs)
});
export { auth_password_errors_password_requires_upper as "auth.password_errors.password_requires_upper" }